import { render, staticRenderFns } from "./TheUserSettingsDialog.vue?vue&type=template&id=77f5b356&"
import script from "./TheUserSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./TheUserSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports